// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1znnq","title":"ClientInsurance_title__wVRsh","itemText":"ClientInsurance_itemText__lukYJ"};